import { roleKey, SUPERADMIN_ONLY } from "../constants/roles";

/**
 * Role helpers for access checks. Names are compared case-insensitively and
 * exactly against the canonical seeded names in constants/roles.js; legacy
 * aliases (CFO, ED, MO ...) are intentionally not accepted.
 */

export function getUserRoleNames(user) {
  const fromArray = (user?.roles || []).map((r) => roleKey(r.name));
  const fallback = user?.role ? [roleKey(user.role)] : [];
  return [...new Set([...fromArray, ...fallback].filter(Boolean))];
}

export function userHasAnyRole(user, allowedNames) {
  const userRoles = getUserRoleNames(user);
  const allowed = (allowedNames || []).map(roleKey);
  return allowed.some((role) => userRoles.includes(role));
}

export function formatBdt(amount, { compact = false } = {}) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return "৳—";

  if (compact) {
    const abs = Math.abs(value);
    if (abs >= 1_000_000_000) {
      return `৳${(value / 1_000_000_000).toFixed(1)}B`;
    }
    if (abs >= 1_000_000) {
      return `৳${(value / 1_000_000).toFixed(1)}M`;
    }
    if (abs >= 100_000) {
      return `৳${(value / 100_000).toFixed(1)}L`;
    }
    if (abs >= 1_000) {
      return `৳${(value / 1_000).toFixed(1)}K`;
    }
  }

  return `৳${value.toLocaleString("en-BD", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

export function formatChangePct(pct) {
  if (pct === null || pct === undefined || Number.isNaN(Number(pct))) {
    return "—";
  }
  const value = Number(pct);
  const sign = value > 0 ? "+" : "";
  return `${sign}${value}%`;
}

export function isSuperadminUser(user) {
  return userHasAnyRole(user, SUPERADMIN_ONLY);
}
